"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canViewStructures = exports.canViewSectionReports = exports.canQueryMileage = exports.canEditAnyMileage = exports.canAddMileage = exports.canViewSignsRemoved = exports.canViewPatrolSummary = exports.canAddEditSectionPatrols = exports.canEditSectionAnnualData = exports.canEditSectionInventories = exports.canCreateEditSections = exports.hasSectionsMenu = exports.canUserUnPayInvoice = exports.canPayOnline = exports.canManageAccountingInfo = exports.canProcessManualPayment = exports.canProcessPayments = exports.canViewAccountingInfo = exports.canViewPayments = exports.canCertifyTagPosting = exports.canManagePermitDetails = exports.canEditFdotFieldSheet = exports.canManagePermitStatus = exports.canManageReviewStatus = exports.canManagePermitTasks = exports.canViewPermits = exports.canEditFdotFieldReviewSheet = exports.canEditConsultantFieldReviewSheet = exports.canManageApplicationInspector = exports.canManageApplicationDetails = exports.canViewApplications = exports.canApplyForPermit = exports.canManageLicenseApplications = exports.canManageAllAccounts = exports.canManageSomeAccounts = exports.canViewAccounts = exports.canRequestAccountAccess = exports.canCreateAccount = exports.hasMyAccountsMenu = exports.canManageConfiguration = exports.canManageFieldConsultants = exports.canManageConsultantRoles = exports.canManageInternalRoles = exports.hasAdminMenu = exports.hasAdminRole = exports.hasAnyFdotRole = exports.hasOnlyThisRole = exports.isFdotAdminOnly = exports.isFdotInspector = exports.isInternalUser = void 0;
exports.canManageFindingTasks = exports.canDeleteFinding = exports.canClearFinding = exports.canCreateEditFinding = exports.canViewFindings = exports.canEditCreateViolation = exports.canViewViolations = exports.canEditCreateNotices = exports.canViewNotices = exports.canViewShoppingCart = exports.canChangeTaskConsultantInspector = exports.canEditAllTasks = exports.canEditMyTasks = exports.canCreateTasks = exports.canViewTasks = exports.canViewSearches = exports.canViewInternalReports = exports.hasDashboard = exports.canViewComplianceReports = exports.canCreateEditIllegalSigns = exports.canViewIllegalSigns = exports.canCreateEditCases = exports.canViewCases = exports.hasComplianceMenu = exports.canEditFacingInventory = exports.canEditFacings = exports.canEditStructureRemovedDate = exports.canEditStructureAnnualInventory = exports.canEditStructure = exports.canMoveStructure = void 0;
var InternalRole_1 = require("../models/enums/InternalRole");
var UserService_1 = require("./UserService");
//Overall view/edit largely based on this, more granular rights added from page controls standardization
//https://fldot.sharepoint.com/:x:/t/COOITOutdoorAdvertisingODA/ETbuQG7YhPlMsHpemTECAPkBjbPEt8GGcRuDcqKpVGA_rQ?e=LnQrF7
//Generic rights
var isInternalUser = function (user) {
    return user && user._id && !user.isExternal ? true : false;
};
exports.isInternalUser = isInternalUser;
var isFdotInspector = function (user) {
    return (0, exports.isInternalUser)(user) && (user === null || user === void 0 ? void 0 : user.internalRoles.length) === 1 && user.internalRoles[0] === InternalRole_1.InternalRole.FdotInspector;
};
exports.isFdotInspector = isFdotInspector;
var isFdotAdminOnly = function (user) {
    return (0, exports.isInternalUser)(user) && (user === null || user === void 0 ? void 0 : user.internalRoles.length) === 1 && user.internalRoles[0] === InternalRole_1.InternalRole.FdotAdmin;
};
exports.isFdotAdminOnly = isFdotAdminOnly;
var hasOnlyThisRole = function (user, thisRole) {
    return (0, exports.isInternalUser)(user) && (user === null || user === void 0 ? void 0 : user.internalRoles.length) === 1 && user.internalRoles[0] === thisRole;
};
exports.hasOnlyThisRole = hasOnlyThisRole;
//User rights matrix says only FDOT users can view reports...how does this apply to field consultants?
var hasAnyFdotRole = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.FdotLegal
    ]);
};
exports.hasAnyFdotRole = hasAnyFdotRole;
var hasAdminRole = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        //InternalRole.FieldSupervisor
    ]);
};
exports.hasAdminRole = hasAdminRole;
//Admin menu
var hasAdminMenu = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.hasAdminMenu = hasAdminMenu;
var canManageInternalRoles = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, exports.hasAdminRole)(user);
};
exports.canManageInternalRoles = canManageInternalRoles;
var canManageConsultantRoles = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.canManageConsultantRoles = canManageConsultantRoles;
var canManageFieldConsultants = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.canManageFieldConsultants = canManageFieldConsultants;
var canManageConfiguration = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, exports.hasAdminRole)(user);
};
exports.canManageConfiguration = canManageConfiguration;
//Accounts
var hasMyAccountsMenu = function (user) {
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ])
        ||
            user.isExternal;
};
exports.hasMyAccountsMenu = hasMyAccountsMenu;
var canCreateAccount = function (user) {
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ])
        ||
            user.isExternal;
};
exports.canCreateAccount = canCreateAccount;
var canRequestAccountAccess = function (user) {
    if (!user || !user._id) {
        return false;
    }
    return user.isExternal;
};
exports.canRequestAccountAccess = canRequestAccountAccess;
var canViewAccounts = function (user) {
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.FdotLegal
    ])
        ||
            (user.isExternal);
};
exports.canViewAccounts = canViewAccounts;
var canManageSomeAccounts = function (user) {
    var _a;
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ])
        ||
            (user.isExternal && ((_a = user.externalAccounts) === null || _a === void 0 ? void 0 : _a.length) > 0);
};
exports.canManageSomeAccounts = canManageSomeAccounts;
var canManageAllAccounts = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.canManageAllAccounts = canManageAllAccounts;
var canManageLicenseApplications = function (user) {
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor
    ]);
};
exports.canManageLicenseApplications = canManageLicenseApplications;
//Applications
var canApplyForPermit = function (user) {
    var _a;
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ])
        ||
            (user.isExternal && ((_a = user.externalAccounts) === null || _a === void 0 ? void 0 : _a.length) > 0);
};
exports.canApplyForPermit = canApplyForPermit;
var canViewApplications = function (user) {
    var _a;
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.FdotLegal
    ])
        ||
            (user.isExternal && ((_a = user.externalAccounts) === null || _a === void 0 ? void 0 : _a.length) > 0)
        || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canViewApplications = canViewApplications;
// export const canManageApplicationStatus = (user: IUser | undefined) => {
//     //Reinstatement, void, manual cancel, permitted sign removal
//     if (!user || !user._id) {
//         return false;
//     }
//     return HasRoles(user, [
//         InternalRole.FdotAdmin,
//         InternalRole.ManagementReviewer,
//         InternalRole.OfficeSupervisor,        
//     ]);
// }
var canManageApplicationDetails = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ]);
};
exports.canManageApplicationDetails = canManageApplicationDetails;
var canManageApplicationInspector = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ]) || user.isFieldConsultantManager;
};
exports.canManageApplicationInspector = canManageApplicationInspector;
var canEditConsultantFieldReviewSheet = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor
    ]) || user.isFieldConsultantManager || user.isFieldConsultantInspector;
};
exports.canEditConsultantFieldReviewSheet = canEditConsultantFieldReviewSheet;
var canEditFdotFieldReviewSheet = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor
    ]);
};
exports.canEditFdotFieldReviewSheet = canEditFdotFieldReviewSheet;
//Permits
var canViewPermits = function (user) {
    return (0, exports.canViewApplications)(user) || (user === null || user === void 0 ? void 0 : user.isFieldConsultantInspector) || (user === null || user === void 0 ? void 0 : user.isFieldConsultantManager);
};
exports.canViewPermits = canViewPermits;
var canManagePermitTasks = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ])
        || user.isFieldConsultantManager
        || user.isFieldConsultantInspector;
};
exports.canManagePermitTasks = canManagePermitTasks;
var canManageReviewStatus = function (user) {
    //For changes of status to a permit or application undergoing review
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.ApplicationReviewer
    ])
        || user.isFieldConsultantManager
        || user.isFieldConsultantInspector;
};
exports.canManageReviewStatus = canManageReviewStatus;
var canManagePermitStatus = function (user) {
    //Submit manual, Reinstatement, void, manual cancel, approving cancels/transfers, permitted sign removal
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
    ]);
};
exports.canManagePermitStatus = canManagePermitStatus;
var canEditFdotFieldSheet = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor
    ]);
};
exports.canEditFdotFieldSheet = canEditFdotFieldSheet;
var canManagePermitDetails = function (user) {
    //Tag replacement
    //Whether 270 day inspection is required
    //Assign FDOT inspector
    //Add docs to an application in any status
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ]);
};
exports.canManagePermitDetails = canManagePermitDetails;
//Probably not in use...?
var canCertifyTagPosting = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    //Can also be done by the inspector assigned to the tag certification
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ]) || user.isFieldConsultantManager;
};
exports.canCertifyTagPosting = canCertifyTagPosting;
//Accounting
var canViewPayments = function (user) {
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ])
        ||
            user.isExternal;
};
exports.canViewPayments = canViewPayments;
var canViewAccountingInfo = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.canViewAccountingInfo = canViewAccountingInfo;
//Taken from PaymentBusinessRules
var canProcessPayments = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.ManagementReviewer, //#52624 Management Reviewver has all roles of Office Supervisor,
        InternalRole_1.InternalRole.ApplicationReviewer
    ]);
};
exports.canProcessPayments = canProcessPayments;
//Taken from PaymentBusinessRules
var canProcessManualPayment = function (user) {
    if (!user || !user._id || user.isExternal === true) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.ManagementReviewer, //#52624 Management Reviewver has all roles of Office Supervisor
        InternalRole_1.InternalRole.ApplicationReviewer
    ]);
};
exports.canProcessManualPayment = canProcessManualPayment;
// export const canCreateEditInvoice = (user: IUser | undefined) => {
//     if (!user || !user._id || user.isExternal === true) {
//         return false;
//     }
//     return HasRoles(user, [
//         InternalRole.FdotAdmin,
//         InternalRole.OfficeStaff,
//         InternalRole.OfficeSupervisor,
//         InternalRole.ManagementReviewer, //#52624 Management Reviewver has all roles of Office Supervisor,
//         InternalRole.FieldSupervisor,
//         InternalRole.ApplicationReviewer
//     ])
// };
var canManageAccountingInfo = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ]);
};
exports.canManageAccountingInfo = canManageAccountingInfo;
//Taken from PaymentBusinessRules
var canPayOnline = function (user) {
    if (!user || !user._id || user.isExternal === false) {
        return false;
    }
    return true;
};
exports.canPayOnline = canPayOnline;
//Taken from PaymentBusinessRules
var canUserUnPayInvoice = function (user) {
    if (!user || !user._id || user.isExternal === true) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.ManagementReviewer, //#52624 Management Reviewver has all roles of Office Supervisor
    ]);
};
exports.canUserUnPayInvoice = canUserUnPayInvoice;
//Sections
var hasSectionsMenu = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.hasSectionsMenu = hasSectionsMenu;
var canCreateEditSections = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]);
};
exports.canCreateEditSections = canCreateEditSections;
var canEditSectionInventories = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canEditSectionInventories = canEditSectionInventories;
var canEditSectionAnnualData = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.FieldSupervisor
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canEditSectionAnnualData = canEditSectionAnnualData;
var canAddEditSectionPatrols = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]);
};
exports.canAddEditSectionPatrols = canAddEditSectionPatrols;
var canViewPatrolSummary = function (user) {
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]);
};
exports.canViewPatrolSummary = canViewPatrolSummary;
var canViewSignsRemoved = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canViewSignsRemoved = canViewSignsRemoved;
var canAddMileage = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FdotInspector
    ]);
};
exports.canAddMileage = canAddMileage;
var canEditAnyMileage = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin
    ]);
};
exports.canEditAnyMileage = canEditAnyMileage;
var canQueryMileage = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]);
};
exports.canQueryMileage = canQueryMileage;
var canViewSectionReports = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canViewSectionReports = canViewSectionReports;
//Structures
var canViewStructures = function (user) {
    return (0, exports.isInternalUser)(user);
};
exports.canViewStructures = canViewStructures;
var canMoveStructure = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.OfficeStaff
    ]);
};
exports.canMoveStructure = canMoveStructure;
var canEditStructure = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.OfficeStaff
        //Note special rules about when the consultants can edit though. Only at 270 day inspections.
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canEditStructure = canEditStructure;
var canEditStructureAnnualInventory = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canEditStructureAnnualInventory = canEditStructureAnnualInventory;
var canEditStructureRemovedDate = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ]);
};
exports.canEditStructureRemovedDate = canEditStructureRemovedDate;
var canEditFacings = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.canEditFacings = canEditFacings;
var canEditFacingInventory = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canEditFacingInventory = canEditFacingInventory;
//Compliance
var hasComplianceMenu = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.FdotLegal
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.hasComplianceMenu = hasComplianceMenu;
var canViewCases = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotLegal
    ]);
};
exports.canViewCases = canViewCases;
var canCreateEditCases = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FdotLegal,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.canCreateEditCases = canCreateEditCases;
var canViewIllegalSigns = function (user) {
    //Only users who can create them can view them
    //Note there are extra rules about when field consultants can view
    return (0, exports.canCreateEditIllegalSigns)(user);
};
exports.canViewIllegalSigns = canViewIllegalSigns;
var canCreateEditIllegalSigns = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    //Note there are extra rules about when field consultants/manager can edit
    //Those rules specified on the page.
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.FdotLegal
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canCreateEditIllegalSigns = canCreateEditIllegalSigns;
var canViewComplianceReports = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.FdotLegal
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canViewComplianceReports = canViewComplianceReports;
//basically the only users that don't have a dashboard are FDOT Admins, legal, and 
var hasDashboard = function (user) {
    if (!user || !user._id || user.isExternal) {
        //unauthenticated users and external users
        return false;
    }
    if (user.isFieldConsultantManager) {
        return true;
    }
    if (user.isFieldConsultantInspector) {
        //redirect to tasks
        return false;
    }
    if (user.internalRoles.length === 1 && (0, UserService_1.HasRoles)(user, [InternalRole_1.InternalRole.FdotAdmin, InternalRole_1.InternalRole.FdotLegal, InternalRole_1.InternalRole.FdotInspector])) {
        //Admin, Legal, and FDOT inspectors do not have dashboards
        return false;
    }
    //Everyone internal other than admin, legal, and fdot inspectors    
    return true;
};
exports.hasDashboard = hasDashboard;
//Reports section - 
//Everyone can view reports.
// export const hasReportsMenu = (user: IUser | undefined): boolean => {
//     if (!user || !user._id || user.isExternal) {
//         return true;
//     }
//     return HasRoles(user, [
//         InternalRole.FdotAdmin,
//         InternalRole.ManagementReviewer,
//         InternalRole.ApplicationReviewer,
//         InternalRole.OfficeSupervisor,
//         InternalRole.OfficeStaff,
//         InternalRole.FieldSupervisor,                
//     ]);
// }
//Public reports available to anonymous users.
//everyone internal can view internal reports except ones on special menus
var canViewInternalReports = function (user) {
    return (0, exports.isInternalUser)(user);
};
exports.canViewInternalReports = canViewInternalReports;
//Searches - it appears any internal user can search for almost anything, so most rights not specified.
var canViewSearches = function (user) {
    return (0, exports.isInternalUser)(user);
};
exports.canViewSearches = canViewSearches;
//Tasks
var canViewTasks = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.FdotInspector
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
};
exports.canViewTasks = canViewTasks;
var canCreateTasks = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.canCreateTasks = canCreateTasks;
var canEditMyTasks = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotInspector
    ]) || user.isFieldConsultantInspector || user.isFieldConsultantManager;
    //Note field consultants/manager can edit tasks only SOMETIMES
};
exports.canEditMyTasks = canEditMyTasks;
var canEditAllTasks = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
    //Note field consultants/manager can edit tasks only SOMETIMES
};
exports.canEditAllTasks = canEditAllTasks;
var canChangeTaskConsultantInspector = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.FieldSupervisor,
    ]) || user.isFieldConsultantManager;
};
exports.canChangeTaskConsultantInspector = canChangeTaskConsultantInspector;
//Others
var canViewShoppingCart = function (user) {
    if (!user || !user._id) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ]) || (user.isExternal && user.externalAccounts);
};
exports.canViewShoppingCart = canViewShoppingCart;
//Notices
var canViewNotices = function (user) {
    return (0, exports.hasAnyFdotRole)(user);
};
exports.canViewNotices = canViewNotices;
var canEditCreateNotices = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.canEditCreateNotices = canEditCreateNotices;
//More detailed rights that apply to parts of pages
//Violations
var canViewViolations = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.FdotLegal
    ])
        || user.isFieldConsultantInspector
        || user.isFieldConsultantManager;
};
exports.canViewViolations = canViewViolations;
var canEditCreateViolation = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FieldSupervisor
    ]);
};
exports.canEditCreateViolation = canEditCreateViolation;
//Findings
var canViewFindings = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff,
        InternalRole_1.InternalRole.FdotInspector,
        InternalRole_1.InternalRole.FdotLegal
    ])
        || user.isFieldConsultantInspector
        || user.isFieldConsultantManager;
};
exports.canViewFindings = canViewFindings;
var canCreateEditFinding = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ])
        || user.isFieldConsultantInspector
        || user.isFieldConsultantManager;
};
exports.canCreateEditFinding = canCreateEditFinding;
var canClearFinding = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.OfficeSupervisor]);
};
exports.canClearFinding = canClearFinding;
var canDeleteFinding = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.OfficeSupervisor
    ]);
};
exports.canDeleteFinding = canDeleteFinding;
var canManageFindingTasks = function (user) {
    if (!user || !user._id || user.isExternal) {
        return false;
    }
    return (0, UserService_1.HasRoles)(user, [
        InternalRole_1.InternalRole.FdotAdmin,
        InternalRole_1.InternalRole.ApplicationReviewer,
        InternalRole_1.InternalRole.ManagementReviewer,
        InternalRole_1.InternalRole.FieldSupervisor,
        InternalRole_1.InternalRole.OfficeSupervisor,
        InternalRole_1.InternalRole.OfficeStaff
    ]);
};
exports.canManageFindingTasks = canManageFindingTasks;
//Permits
